import { Link } from "react-router-dom";
import SidebarTitle from "../sidebar-title";

const SidebarWorkingTime = () => {
    return (
        <div className="widget-item">
            <div className="widget-work-hours">
                <SidebarTitle classOption="title" title="진료 시간" />
                <ul>
                    <li>
                        <span className="work-day">월, 화, 목, 금</span>
                        <span className="work-hours">06:30 - 15:30</span>
                    </li>
                    <li>
                        <span className="work-day">수요일</span>
                        <span className="work-hours">휴진</span>
                    </li>
                    <li>
                        <span className="work-day">토요일</span>
                        <span className="work-hours">05:30 - 10:30</span>
                    </li>
                    <li>
                        <span className="work-day">일요일</span>
                        <span className="work-hours">휴진</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default SidebarWorkingTime;
